import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PremiumLessQuoteComponent } from './premium-less-quote.component';
import { CpIconModule } from '../../../../../../coverpath-common/components/cp-icon/cp-icon.module';
import { CpGenericModalModule } from '../../../../../../coverpath-common/components/cp-generic-modal/cp-generic-modal.module';
import { CpFormFieldModule } from '../../../../../../coverpath-common/components/form-field/form-field.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../../../coverpath-common/angular/components/shared/shared.module';
import { ToggleButtonModule } from '../../../../../../coverpath-common/components/toggle-button/toggle-button.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [PremiumLessQuoteComponent],
  imports: [
    CommonModule,
    FormsModule,
    CpGenericModalModule,
    CpFormFieldModule,
    ReactiveFormsModule,
    CpIconModule,
    SharedModule,
    ToggleButtonModule,
  ],
  entryComponents: [PremiumLessQuoteComponent],
  exports: [PremiumLessQuoteComponent],
})
export class PremiumLessQuoteModalModule {}
